import { Calendar } from 'lucide-react';
import { MatchList } from '../components/matches/MatchList';
import { Helmet } from 'react-helmet-async';

export function Fixtures() {
  return (
    <>
      <Helmet>
        <title>Fixtures | Upcoming Matches at Aker Stadium</title>
        <meta 
          name="description" 
          content="Complete fixture list for upcoming matches at Aker Stadium. Plan your next visit and get an overview of Molde FK's home games."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Calendar className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Fixtures</h1>
            </div>
            <p className="text-lg opacity-90">
              Upcoming matches at Aker Stadium
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
            <MatchList type="next" limit={30} />
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-2xl font-bold mb-4">Match Overview and Fixtures</h2>
            <p className="text-gray-600 mb-6">
              Here you'll find a complete overview of upcoming matches and events at Aker Stadium. 
              Stay updated on when Molde FK plays their next home games, and plan your 
              visit well in advance. The fixture list is regularly updated to give you the latest 
              information about both national and international matches.
            </p>

            <h3 className="text-xl font-bold mb-3">Plan Your Visit</h3>
            <p className="text-gray-600">
              Whether you're a dedicated supporter or just want to experience the atmosphere at Aker Stadium, 
              the fixture list is your guide to all upcoming matches and events. Make sure to catch the 
              season's highlights and become part of the community in the stands.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
